enum DispatcherHubEvent {
  RidesChanged = "RidesChangedAsync",
  IncomingCallStarted = "IncomingCallStartedAsync",
  CallRemovedFromQueue = "CallRemovedFromQueueAsync",
  IncomingCallEnded = "IncomingCallEndedAsync",
  CallAnswered = "CallAnsweredAsync",
}

export default DispatcherHubEvent;
